import { render, staticRenderFns } from "./SearchUnattachedDocuments.vue?vue&type=template&id=1f800819&scoped=true"
import script from "./SearchUnattachedDocuments.vue?vue&type=script&lang=js"
export * from "./SearchUnattachedDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f800819",
  null
  
)

export default component.exports